<template>
  <div>
    <div class="side-frame-danger">
      <span style="font-size: 14px; color: #606266">
        {{ $l('INDEX.booking_backfill_cabinet_info') || '回填柜信息' }}
      </span>
      <el-divider direction="vertical" v-if="isNStatus"></el-divider>
      <b-button-group size="sm" v-if="isNStatus">
        <b-button
          class="mr-2"
          variant="outline-success"
          @click="$emit('openAddDialog')"
          :disabled="disabled"
        >
          <i class="el-icon-plus" />
          {{ $l('INDEX.btn_add') || '添加' }}
        </b-button>
        <b-button
          :disabled="disabled"
          variant="outline-danger"
          @click="$emit('batchDel')"
        >
          <i class="el-icon-delete"></i>
          {{ $l('INDEX.btn_delete') || '删除' }}
        </b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    isNStatus: { type: Boolean, default: false },
  },
}
</script>
